export enum LegendStatus {
  LBR = "Libre",
  RSV = "Verrouillé",
  INV = "Inventaire",
  RCPT = "Réception",
  EXPN = "Expédition",
  OIP = "Opération en cours",
  STK = "Stack",
  PAL = "Palette",
  CAG = "Cage",
  MANUAL = "Manuel",
  AUTOMATED = "Automatisé",
  OTHER = "Autres",
}
